// frontend/src/pages/LoginPage.js
import React from 'react';
import LoginForm from '../components/Auth/LoginForm';
import { Link } from 'react-router-dom';

const LoginPage = () => {
  return (
    <div className="min-h-[calc(100vh-var(--navbar-height,88px)-var(--footer-height,88px))] flex flex-col items-center justify-center bg-gradient-to-b from-white to-blue-50 py-12 px-4 sm:px-6 lg:px-8">
      {/*
        --navbar-height and --footer-height would be set in a global CSS or via JS if dynamic.
        Alternatively, ensure AppLayout's <main> and this page's div correctly fill the space.
        A simpler approach if AppLayout's <main> already has correct padding:
      */}
    {/* <div className="flex flex-col items-center justify-center flex-grow bg-gradient-to-b from-white to-blue-50 py-12 px-4 sm:px-6 lg:px-8"> */}

      <div className="w-full max-w-md space-y-8">
        <div className="text-center">
            <h2 className="text-center text-2xl font-bold tracking-tight text-gray-900">
            Sign in to your account
            </h2>
        </div>

        <LoginForm />

        <p className="mt-10 text-center text-sm text-gray-500">
          Not a member?{' '}
          <Link to="/register" className="font-semibold leading-6 text-blue-600 hover:text-blue-500">
            Register for a new account
          </Link>
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
